import { Controller } from "@hotwired/stimulus";

export default class AuthSyncController extends Controller {
  static targets = ["input"];

  connect() {
    this.tabId = sessionStorage.getItem("auth_sync_tab_id");

    if (!this.tabId) {
      this.tabId = crypto.randomUUID();
      sessionStorage.setItem("auth_sync_tab_id", this.tabId);
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = this.tabId;
    }
  }

  inputTargetConnected(element) {
    element.value = this.tabId;
  }

  getTabId() {
    return this.tabId;
  }
}
